import { useCommonMutation, useCommonQuery } from 'hooks';
import { LoginAPI, ReqLogin, ResLogin } from 'domains/Auth';
import { BaseApiResponse, ResultError } from 'modules';
import { TermsKeys } from '../keys/terms.key';
import { TermsAPI } from '../apis/terms.api';
import { useQuery } from '@tanstack/react-query';

const termsApi = new TermsAPI();

export const useFetchTerms = () => {
  return useQuery({
    queryKey: TermsKeys.FETCH_TERMS(),
    queryFn: () => termsApi.fetchTerms()
  });
};

export const useFetchPrivacy = () => {
  return useQuery({
    queryKey: TermsKeys.FETCH_PRIVACY(),
    queryFn: () => termsApi.fetchPrivacy()
  });
};
